import { createGlobalStore } from 'hox';
import { useState } from 'react';

export interface Days {
  [key: string]: string;
}

function useDashboardDays(defDays?: Days) {
  const [days, setDays] = useState<Days>(defDays || {});

  const loadLocalStorage = () => {
    try {
      const text = localStorage.getItem('casDashboardDays');
      if (text) {
        setDays(JSON.parse(text));
      }
    } catch (err) {
      // prevent crash, do nothing here
    }
  };

  const setDay = (widgetId: string, day: string) => {
    days[widgetId] = day;
    setDays({ ...days });
    setTimeout(() => {
      localStorage.setItem('casDashboardDays', JSON.stringify(days));
    }, 0);
  };

  const setAllDays = (day: string) => {
    const newDays = { ...days };
    for (const widgetId in newDays) {
      newDays[widgetId] = day;
    }
    setDays(newDays);
    setTimeout(() => {
      localStorage.setItem('casDashboardDays', JSON.stringify(newDays));
    }, 0);
  };

  return {
    days,
    loadLocalStorage,
    setDay,
    setAllDays,
  };
}

export const [useDashboardDaysStore] = createGlobalStore(useDashboardDays);
